// eslint-disable-next-line import/no-unresolved
import mem from 'mem';
import { createContext } from '../context-key.js';
/**
 * Lazy loading () => import(...) is a common way we provide services, just a little wrapper to make that more convienient
 */
export function createLazyContext(key) {
    return createContext(key);
}
/**
 * dynamically load a module, memoized so that the same instance is reused
 * commonly used with createLazyContext to provide lazily loaded context
 * @param importFn parameterless function that returns a dynamic import promise
 * @param resolve callback that takes the module imported by importFn() as a parameter and returns a value (module.default)
 * @returns function that returns a promise
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyLoadContext = (importFn, resolve = (mod) => mod.default) => {
    const loader = async () => {
        const module = await importFn();
        return resolve(module);
    };
    return mem(loader);
};
//# sourceMappingURL=context-key-lazy.js.map